import env from './env'
import getDefaultConfig from '@ivy/fts/config'

let conf = {
  ...getDefaultConfig(env), // 多个项目公用的appid等等
  apiList: ['onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
  openTagList: ['wx-open-launch-app']
}
console.log('config is: ', conf)
export default conf
